/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ContainerDetailsResponse,
  ContainerGoodsOverviewPaginatedDto,
  ContainerIdsPaginatedDto,
  ContainerOverviewPaginatedDto,
  ContainerTrackingDetailsResponse,
  DownloadDocumentResponse,
  ErrorResponseDto,
  ExportContainersParams,
  GetContainerGoodsOverviewParams,
  GetContainersCountParams,
  GetContainersIdsParams,
  GetContainersOverviewParams,
  SaveVgmPayload,
  SubmitVgmPayload,
  TotalCountDto,
  VgmEntryResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Containers<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Containers
   * @name ExportContainers
   * @summary Export all containers
   * @request GET:/v1/containers/export
   * @response `200` `DownloadDocumentResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  exportContainers = (query: ExportContainersParams, params: RequestParams = {}) =>
    this.http.request<DownloadDocumentResponse, ErrorResponseDto>({
      path: `/v1/containers/export`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name GetContainerDetails
   * @summary Get container details
   * @request GET:/v1/containers/{id}
   * @response `200` `ContainerDetailsResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getContainerDetails = (id: string, params: RequestParams = {}) =>
    this.http.request<ContainerDetailsResponse, ErrorResponseDto>({
      path: `/v1/containers/${id}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name GetContainerGoodsOverview
   * @summary Get all goods for a container
   * @request GET:/v1/containers/{id}/goods
   * @response `200` `ContainerGoodsOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getContainerGoodsOverview = ({ id, ...query }: GetContainerGoodsOverviewParams, params: RequestParams = {}) =>
    this.http.request<ContainerGoodsOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/containers/${id}/goods`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name GetContainersCount
   * @summary Get containers count
   * @request GET:/v1/containers/count
   * @response `200` `TotalCountDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getContainersCount = (query: GetContainersCountParams, params: RequestParams = {}) =>
    this.http.request<TotalCountDto, ErrorResponseDto>({
      path: `/v1/containers/count`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name GetContainersIds
   * @summary Get all containers ids
   * @request GET:/v1/containers/ids
   * @response `200` `ContainerIdsPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getContainersIds = (query: GetContainersIdsParams, params: RequestParams = {}) =>
    this.http.request<ContainerIdsPaginatedDto, ErrorResponseDto>({
      path: `/v1/containers/ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name GetContainersOverview
   * @summary Get all containers
   * @request GET:/v1/containers
   * @response `200` `ContainerOverviewPaginatedDto`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getContainersOverview = (query: GetContainersOverviewParams, params: RequestParams = {}) =>
    this.http.request<ContainerOverviewPaginatedDto, ErrorResponseDto>({
      path: `/v1/containers`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name GetContainerTrackingDetails
   * @summary Get tracking details for a container
   * @request GET:/v1/containers/{id}/tracking-details
   * @response `200` `ContainerTrackingDetailsResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getContainerTrackingDetails = (id: string, params: RequestParams = {}) =>
    this.http.request<ContainerTrackingDetailsResponse, ErrorResponseDto>({
      path: `/v1/containers/${id}/tracking-details`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name GetVgmEntry
   * @summary Get VGM entry for a container
   * @request GET:/v1/containers/{id}/vgm
   * @response `200` `VgmEntryResponse`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  getVgmEntry = (id: string, params: RequestParams = {}) =>
    this.http.request<VgmEntryResponse, ErrorResponseDto>({
      path: `/v1/containers/${id}/vgm`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name SaveVgm
   * @summary Save VGM entries for one or more containers
   * @request POST:/v1/containers/vgm/save
   * @response `200` `(VgmEntryResponse)[]`
   * @response `201` `(VgmEntryResponse)[]`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  saveVgm = (data: SaveVgmPayload, params: RequestParams = {}) =>
    this.http.request<VgmEntryResponse[], ErrorResponseDto>({
      path: `/v1/containers/vgm/save`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Containers
   * @name SubmitVgm
   * @summary Save and submit VGM entries for one or more containers
   * @request POST:/v1/containers/vgm/submit
   * @response `204` `void`
   * @response `400` `ErrorResponseDto` Bad Request
   * @response `401` `ErrorResponseDto` Unauthorized
   * @response `403` `ErrorResponseDto` Forbidden
   * @response `404` `ErrorResponseDto` Not Found
   * @response `500` `ErrorResponseDto` Internal Server Error
   */
  submitVgm = (data: SubmitVgmPayload, params: RequestParams = {}) =>
    this.http.request<void, ErrorResponseDto>({
      path: `/v1/containers/vgm/submit`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
}
